import { useIntl } from 'react-intl';
import { useEffect } from 'react';
import { SectionHeading, Input, InputProps } from '@ets/design-system';

import { useDispatch, useSelector } from '_common/hooks';
import { openModal } from '_common/modals/ModalsSlice';

import { FilterContent } from '_common/components';
import { clearFilterIdentity, useFilterSelector } from '_common/components/Filters/FilterSlice';

export type HeaderProps = {
  searchValue?: string;
  onSearchChange: (newSearch: string) => void;
};

const HeaderContent = ({ onSearchChange, searchValue }: HeaderProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { selectAppliedFilterCount } = useFilterSelector();
  const appliedFilterCount = useSelector((state) =>
    selectAppliedFilterCount(state, state.filters['tenantSettings_users']),
  );

  useEffect(() => {
    return () => {
      dispatch(clearFilterIdentity({ identity: 'tenantSettings_users', noFeedback: true }));
    };
  }, []);

  const handleValueChange: InputProps['onChange'] = (e) => {
    onSearchChange(e.target.value);
  };

  const openFormModal = () => {
    dispatch(openModal('UserManagementFormModal'));
  };

  const openUploadModal = () => {
    dispatch(openModal('UploadUsersModal'));
  };

  return (
    <SectionHeading
      title={intl.formatMessage({ id: 'spaces.users' })}
      size="l"
      searchBar={
        <Input
          size="m"
          prefix="search"
          placeholder={intl.formatMessage({
            id: 'PLACEHOLDER_SEARCH_USERS',
          })}
          onChange={handleValueChange}
          value={searchValue}
          testId="users-header-search"
          margin="0 1rem 0 0"
          width="31rem"
        />
      }
      filterPopoverProps={{ align: 'end' }}
      filterContent={
        <FilterContent
          identity="tenantSettings_users"
          userPermissions={{
            options: [{ value: 'tenant_admin', label: 'ADMINISTRATOR' }],
          }}
          persist
        />
      }
      filterTriggerProps={{
        iconProps: {
          icon: appliedFilterCount ? 'regular-filters-circle-check' : 'filters',
        },
        iconPrefixActive: appliedFilterCount ? 'fak' : 'fas',
        iconPrefixInactive: appliedFilterCount ? 'fak' : 'far',
      }}
      secondAction={{
        children: intl.formatMessage({ id: 'UPLOAD_USER' }),
        margin: '0 0 0 1rem',
        onClick: openUploadModal,
      }}
      firstAction={{
        children: intl.formatMessage({ id: 'NEW_USER' }),
        onClick: openFormModal,
        variant: 'primary',
      }}
      testId="users"
    />
  );
};

export default HeaderContent;
